import { render, staticRenderFns } from "./CommissionTopbar.vue?vue&type=template&id=4f040a84"
import script from "./CommissionTopbar.vue?vue&type=script&lang=js"
export * from "./CommissionTopbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports